export enum CustomerStatusEnum {
    NONE = 0,
    ANONYMOUS = 1,
    IDENTIFIED = 2,
    REGISTERED = 3,
    ACTIVATED = 4,
    EXPIRED = 5
}